import {
    FundParseExposureChartsSummary,
    FundParseExposureDimensionKey,
    FundParseExposureDimensionSummary,
    FundParseExposureSlice
} from "./fundParseTypes";

export const EXPOSURE_CHARTS_FILENAME = "exposure_charts.json";

export const EXPOSURE_DIMENSION_OPTIONS: { value: FundParseExposureDimensionKey; label: string }[] = [
    { value: "cic_bucket", label: "Asset class (CIC bucket)" },
    { value: "issuer_country", label: "Issuer country" },
    { value: "quotation_currency", label: "Quotation currency" },
    { value: "bond_credit_quality_step", label: "Bond credit quality step" }
];

export function getExposureDimensionFootnote(dimension: FundParseExposureDimensionSummary | undefined): string {
    if (!dimension) {
        return "";
    }
    if (dimension.scope === "lookthrough_with_excluded_panel") {
        return "Bond, equity and cash use the same CIC buckets as the look-through CSV risk files. Derivatives and other positions are shown separately below the chart.";
    }
    if (dimension.scope === "lookthrough_only") {
        return "Includes bond, equity and cash positions only (same scope as look-through CSVs).";
    }
    if (dimension.scope === "bond_only") {
        return "Includes bond positions only, grouped by credit quality step (field 59).";
    }
    return "";
}

export function getExposureChartSlices(
    dimensionKey: FundParseExposureDimensionKey,
    summary: FundParseExposureChartsSummary
): FundParseExposureSlice[] {
    const dimension = summary.dimensions[dimensionKey];
    if (!dimension) {
        return [];
    }

    if (dimensionKey === "cic_bucket") {
        return dimension.lookthrough || [];
    }

    const slices = [...(dimension.slices || [])];
    if (dimension.otherSlice) {
        slices.push(dimension.otherSlice);
    }
    return slices;
}

export function getExposureExcludedSummary(
    dimensionKey: FundParseExposureDimensionKey,
    summary: FundParseExposureChartsSummary
) {
    if (dimensionKey !== "cic_bucket") {
        return null;
    }
    return summary.dimensions.cic_bucket?.excluded || null;
}

export function formatExposureAmount(value: number, currency: string): string {
    const formatted = value.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    if (!currency) {
        return formatted;
    }
    return `${formatted} ${currency}`;
}

export function formatExposureShare(chartValue: number, totalChartValue: number): string {
    if (totalChartValue <= 0) {
        return "0%";
    }
    return `${((chartValue / totalChartValue) * 100).toFixed(1)}%`;
}

export function buildExposurePieColors(slices: FundParseExposureSlice[]): string[] {
    const palette = ["#2563eb", "#059669", "#d97706", "#7c3aed", "#db2777", "#0891b2", "#4f46e5", "#65a30d", "#ea580c", "#0f766e"];
    return slices.map((slice, index) => (slice.isNegative ? "#fca5a5" : palette[index % palette.length]));
}
